import { render, staticRenderFns } from "./publicGoods.vue?vue&type=template&id=5444e382&scoped=true&"
import script from "./publicGoods.vue?vue&type=script&lang=js&"
export * from "./publicGoods.vue?vue&type=script&lang=js&"
import style0 from "./publicGoods.vue?vue&type=style&index=0&id=5444e382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444e382",
  null
  
)

export default component.exports